// removed by extract-text-webpack-plugin
module.exports = {"CourseLink":"_2tmWceBRr97irm2Qr72pBR","CourseIcon":"_3PjpcchMybCbVrejoEJANW","RatingContainer":"qYeWYrRsuTMXnQGY6oJwt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/SearchResult.css
// module id = 1373
// module chunks = 0